// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bbb_a bhc_i bhc_q bhc_j"};